/* import __COLOCATED_TEMPLATE__ from './seller-postings-search-results.hbs'; */
import Component from '@glimmer/component';

class SellerPostingsSearchResultsComponent extends Component {
  get sortValue() {
    return this.args.sortValue;
  }

  set sortValue(value) {
    this.args.sortChanged(value);
  }

  get iconSort() {
    return this.args.iconSort;
  }

  set iconSort(value) {
    this.args.iconSortChanged(value);
  }

  get filterValue() {
    return this.args.filterValue;
  }

  set filterValue(value) {
    this.args.filterChanged(value);
  }

  get disableNextPage() {
    return this.args.currentPage >= this.args.totalPages;
  }

  get disablePreviousPage() {
    return this.args.currentPage <= 1;
  }

  get pageControlsDisplayString() {
    const { total, currentPage, pageSize } = this.args;

    const displayPageMin = (currentPage - 1) * pageSize + 1;
    const displayPageMax = Math.min(currentPage * pageSize, total);

    return `${displayPageMin} - ${displayPageMax} of ${total}`;
  }
}

export default SellerPostingsSearchResultsComponent;
